import { useRouter } from "next/router";

import { useContext, useEffect, useMemo, useState } from "react";

import { filter, findIndex } from "lodash";
import { twMerge } from "tailwind-merge";
import { useEffectOnce } from "usehooks-ts";

import CustomCard from "components/CustomCard";
import SignInForm from "components/SignInForm";
import Swipper from "components/Swipper";
import { TopNavBarContext } from "components/TopNavBar/TopNavBarContext";
import useAuthentication from "hooks/useAuthentication";
import useMediaQuery from "hooks/useMediaQuery";

import DiscussionPageTabs, { tabs } from "../DiscussionsPageTabs";

type DashboardPageMobileProps = {
  children: React.ReactNode;
};

const DiscussionPageMobileLayout = ({ children }: DashboardPageMobileProps) => {
  const { setShowBackButton } = useContext(TopNavBarContext);

  const router = useRouter();

  const { mobile } = useMediaQuery();
  const { authenticated } = useAuthentication();

  const currentTab = router.query?.tab as string;

  const filteredTabs: any = useMemo(() => {
    return filter(tabs, (tab: any) => {
      if (mobile) {
        return tab.mobile;
      }

      return tab;
    });
  }, [mobile]);

  const [index, setIndex] = useState(0);

  useEffectOnce(() => {
    setShowBackButton(false);
  });

  useEffect(() => {
    if (currentTab) {
      setIndex(
        findIndex(filteredTabs, (item: any) => {
          return item.filters.includes(currentTab);
        }) || 0
      );
    }
  }, [currentTab, filteredTabs]);

  if (!authenticated) {
    return (
      <div
        className={twMerge(
          "bg-[#eee]",
          "mt-[54px] py-[10px]",
          "flex flex-col min-h-screen p-[15px]"
        )}
      >
        <CustomCard>
          <SignInForm />
        </CustomCard>
      </div>
    );
  }

  return (
    <div
      className={twMerge(
        "bg-[#eee]",
        "mt-[56px]",
        "p-0 md:px-[5px] md:py-[10px]",
        "min-h-[100vh]"
      )}
    >
      <DiscussionPageTabs />
      <Swipper
        index={index}
        maxIndex={filteredTabs.length}
        onIndexChange={(index) => {
          router.push(filteredTabs[index].href);
        }}
      >
        <div className={twMerge("bg-white", "pt-[56px]")}>{children}</div>
      </Swipper>
    </div>
  );
};

export default DiscussionPageMobileLayout;
